import { ITeamMemberState } from '../../../types'
import { ActionHandlerMap } from '../../../types/common'
import { createActionHandler, mergeMap, removeById } from '../../../utils/state'
import { ITeamMemberAction } from '../../actions/team_members'
import * as constants from '../../constants'

const initTeamMemberState: ITeamMemberState = {
  items: {},
  roles: {},
  isFetching: false,
  isProcessing: false,
  total: 0,
  filters: {}
}

export function teamMember(state: ITeamMemberState, action: ITeamMemberAction): ITeamMemberState {
  if (typeof state === 'undefined') {
    return initTeamMemberState
  }

  switch (action.type) {
    case constants.TEAM_MEMBER_LIST_REQUEST: {
      return { ...state, isFetching: true }
    }

    case constants.TEAM_MEMBER_LIST_SUCCESS: {
      const { items, total } = action.payload
      const members = {}
      items.forEach(tm => {
        members[tm.id] = tm
      })
      return {
        ...state,
        isFetching: false,
        items: members,
        total
      }
    }

    case constants.TEAM_MEMBER_LIST_FAIL: {
      return {
        ...state,
        isFetching: false,
        error: action.payload
      }
    }

    case constants.TEAM_MEMBER_INVITE_REQUEST: {
      return { ...state, isProcessing: true }
    }

    case constants.TEAM_MEMBER_INVITE_SUCCESS: {
      const teamMember = action.payload
      const items = mergeMap(state.items, { [teamMember.id]: teamMember })
      return { ...state, items, isProcessing: false }
    }

    case constants.TEAM_MEMBER_INVITE_FAIL: {
      return { ...state, error: action.payload, isProcessing: false }
    }

    case constants.TEAM_MEMBER_FETCH_REQUEST: {
      return { ...state, isFetching: true }
    }

    case constants.TEAM_MEMBER_FETCH_SUCCESS: {
      const teamMember: any = action.payload
      const t = { [teamMember.id]: teamMember }
      return { ...state, items: mergeMap(state.items, t), isFetching: false }
    }

    case constants.TEAM_MEMBER_FETCH_FAIL: {
      return { ...state, error: action.payload, isFetching: false }
    }

    case constants.TEAM_MEMBER_UPDATE_SUCCESS: {
      const teamMember = action.payload
      return {
        ...state,
        items: mergeMap(state.items, { [teamMember.id]: teamMember })
      }
    }

    case constants.TEAM_MEMBER_ARCHIVE_SUCCESS: {
      const teamMember = action.payload
      return { ...state, items: removeById({ ...state.items }, teamMember.id) }
    }

    case constants.TEAM_MEMBER_RESTORE_SUCCESS: {
      const teamMember = action.payload
      return { ...state, items: removeById({ ...state.items }, teamMember.id) }
    }
    case constants.UPDATE_TEAM_MEMBER_FILTERS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      })
    }
    case constants.RESET_TEAM_MEMBER_FILTERS: {
      return Object.assign({}, state, {
        items: {},
        filters: {
          ...state.filters,
          search: ''
        }
      })
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/team_members/index.ts